import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { NumberInput } from '@hivebrite/design-system/Inputs';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { PageImageItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/pageImageItemAttributess';

const ImageSizeSetting = ({
  item,
  onChange,
}: ComponentSettingsTab<PageImageItemAttributes>) => {
  const [dimensions, setDimensions] = useState({ height: 0, width: 0 });

  useEffect(() => {
    setDimensions({
      height: item.attributes?.height || dimensions.height,
      width: item.attributes?.width || dimensions.width,
    });
  }, [
    item.attributes?.height,
    item.attributes?.width,
    dimensions.height,
    dimensions.width,
  ]);

  const handleChange = (e, side) => {
    const inputValue = e.target.value;

    setDimensions({ ...dimensions, [side]: inputValue });

    onChange({
      id: item.id,
      settingKey: `attributes.${side}`,
      value: parseInt(inputValue, 10),
    });
  };

  return (
    <Wrapper>
      <InputTitle
        boxProps={{ mr: 3 }}
        id={`settingsNumber-${item.id}`}
        label={__('Image Size')}
      />
      <Box alignItems="center">
        <NumberInput
          dataTestId={`settingsNumber-${item.id}-width`}
          id={`settingsNumber-${item.id}-width`}
          name={`settingsNumber-${item.id}-width`}
          onChange={(e) => handleChange(e, 'width')}
          value={Math.round(dimensions.width) ?? ''}
          variant="small"
          width={55}
        />
        <Box m={2}>x</Box>
        <NumberInput
          dataTestId={`settingsNumber-${item.id}-height`}
          id={`settingsNumber-${item.id}-height`}
          name={`settingsNumber-${item.id}-height`}
          onChange={(e) => handleChange(e, 'height')}
          value={Math.round(dimensions.height) ?? ''}
          variant="small"
          width={55}
        />
        <Box m={1}>px</Box>
      </Box>
    </Wrapper>
  );
};

export default ImageSizeSetting;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;
